import { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Radio, RadioGroup, FormControlLabel, Box, Typography,
} from '@mui/material';
import { FaFileExcel, FaFilePdf } from 'react-icons/fa';
import { FormatoRelatorio } from '../relatorio';

interface ModalEscolhaFormatoRelatorioProps {
    open: boolean;
    onClose: () => void;
    onConfirmar: (formato: FormatoRelatorio) => void;
    titulo?: string;
}

export default function ModalEscolhaFormatoRelatorio({
    open,
    onClose,
    onConfirmar,
    titulo,
}: ModalEscolhaFormatoRelatorioProps) {
    const [formato, setFormato] = useState<FormatoRelatorio>('pdf');

    // Cada nova abertura volta para o default PDF.
    useEffect(() => {
        if (open) setFormato('pdf');
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontWeight: 600, color: '#1F467E' }}>
                {titulo ?? 'Como deseja gerar o relatório?'}
            </DialogTitle>
            <DialogContent dividers>
                <RadioGroup value={formato} onChange={(e) => setFormato(e.target.value as FormatoRelatorio)}>
                    <FormControlLabel
                        value="pdf"
                        control={<Radio />}
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <FaFilePdf color="#e53935" />
                                <Box>
                                    <Typography sx={{ fontWeight: 500 }}>PDF</Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Formatado para impressão e visualização rápida.
                                    </Typography>
                                </Box>
                            </Box>
                        }
                        sx={{ alignItems: 'flex-start', mb: 1 }}
                    />
                    <FormControlLabel
                        value="xlsx"
                        control={<Radio />}
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <FaFileExcel color="#2e7d32" />
                                <Box>
                                    <Typography sx={{ fontWeight: 500 }}>Planilha (XLSX)</Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Dados em colunas para filtrar/somar no Excel ou Google Sheets.
                                    </Typography>
                                </Box>
                            </Box>
                        }
                        sx={{ alignItems: 'flex-start' }}
                    />
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">Cancelar</Button>
                <Button
                    onClick={() => onConfirmar(formato)}
                    variant="contained"
                    sx={{ backgroundColor: '#1F467E', '&:hover': { backgroundColor: '#163354' } }}
                    startIcon={formato === 'pdf' ? <FaFilePdf /> : <FaFileExcel />}
                >
                    Gerar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
